module.exports = __webpack_public_path__ + "static/media/zelinskyCollectionDvd04.c308e28e.jpg";